import React from 'react'
import { useTranslation } from 'react-i18next'
import { DescriptionFieldProps } from '../../../../../../../@types/types'
import { DescriptionScreenValidationResult } from '../../../../../../../@types/validation-types'
import TextArea from '../../../../../../common/inputs/textArea/TextArea'

export const AdFurnishingNote: React.FC<DescriptionFieldProps<DescriptionScreenValidationResult>> = ({
  insertionData,
  validationMessages,
  screenName,
  onChange,
}) => {
  const { t } = useTranslation()
  return (
    <div className='grid-item margin-top-m'>
      <TextArea
        id='ad-furnishing-note'
        name='adFurnishingNote'
        rows={3}
        placeholder={t(
          'wizard.screen.description.adFurnishingNotePlaceholder',
          'e.g. oak parquet, floor-to-ceiling windows, fireplace, underfloor heating'
        )}
        allowResize={true}
        errors={validationMessages!.adFurnishingNote ?? []}
        value={insertionData.adFurnishingNote}
        label={t('wizard.screen.description.adFurnishingNote', 'Ad furnishing note')}
        showMaxLengthLabel={true}
        maxLength={2000}
        onChange={(property, value) => onChange({ screen: screenName, property }, value)}
      />
    </div>
  )
}
